export const PageWhiteShadow = () => {
  return (
    <div
      className="hidden lg:block rounded-page-widget max-w-[calc(558px*var(--scale-factor))] max-h-[calc(100%-(128px*var(--scale-factor)))] size-full absolute inset-y-0 my-fluid-16 left-1/2 -translate-x-1/2"
      style={{
        boxShadow: '0 0 0 100vmax rgba(255, 255, 255, 0.15)', // White overlay outside the div
      }}
    />
  )
}
